import * as Yup from "yup";
import { useIntl } from "react-intl";
import moment from "moment";

export default function useCuideoAsistServiceValuationFormValidation() {
  const { formatMessage } = useIntl();

  const validationSchema = Yup.object({
    Nombre_U1: Yup.string().required(
      formatMessage({
        id: "ValuationForm.NameRequired",
        defaultMessage: "El nombre es obligatorio",
      })
    ),
    Primer_apellido_U1: Yup.string().required(
      formatMessage({
        id: "ValuationForm.SurnameRequired",
        defaultMessage: "El primer apellido es obligatorio",
      })
    ),
    Fecha_de_nacimiento_U1: Yup.mixed().test(
      "valid_date",
      formatMessage({
        id: "ValuationForm.BirthdateNotValid",
        defaultMessage: "La fecha de nacimiento ha de ser válida",
      }),
      (value) => {
        const momDate = moment(value);
        if (momDate.isValid()) {
          return true;
        }
        return false;
      }
    ),
    Patologias_U1: Yup.array().min(
      1,
      formatMessage({
        id: "ValuationForm.Min1Pathology",
        defaultMessage: "Debes incluir las patologías del usuario",
      })
    ),

    Nombre_U2: Yup.string().when("Usuarios_a_cuidar", {
      is: "2",
      then: Yup.string().required(
        formatMessage({
          id: "ValuationForm.NameRequired2",
          defaultMessage: "El nombre de U2 es obligatorio",
        })
      ),
    }),
    Primer_apellido_U2: Yup.string().when("Usuarios_a_cuidar", {
      is: "2",
      then: Yup.string().required(
        formatMessage({
          id: "ValuationForm.SurnameRequired2",
          defaultMessage: "El primer apellido de U2 es obligatorio",
        })
      ),
    }),
    Fecha_de_nacimiento_U2: Yup.mixed().when("Usuarios_a_cuidar", {
      is: "2",
      then: Yup.mixed().test(
        "valid_date",
        formatMessage({
          id: "ValuationForm.Birthdate2NotValid",
          defaultMessage: "La fecha de nacimiento de U2 ha de ser válida",
        }),
        (value) => {
          const momDate = moment(value);
          if (momDate.isValid()) {
            return true;
          }
          return false;
        }
      ),
    }),
    Patologias_U2: Yup.array().when("Usuarios_a_cuidar", {
      is: "2",
      then: Yup.array().min(
        1,
        formatMessage({
          id: "ValuationForm.Min1Pathology2",
          defaultMessage: "Debes incluir las patologías del usuario U2",
        })
      ),
    }),

    Inicio_de_servicio: Yup.mixed().test(
      "valid_date",
      formatMessage({
        id: "ValuationForm.La fecha de inicio de servicio ha de ser válida",
        defaultMessage: "La fecha de inicio de servicio ha de ser válida",
      }),
      (value) => {
        const momDate = moment(value);
        if (momDate.isValid()) {
          return true;
        }
        return false;
      }
    ),
  });

  return validationSchema;
}
